import $ from 'jquery';

/**
 * "current / total" counter on the Bootstrap carousels (.carousel .number),
 * e.g. the property cards.
 */
export function initCarouselCounter() {
    window.addEventListener('slide.bs.carousel', function (event) {
        printCarouselNumbers(event.target);
    });

    window.addEventListener('slid.bs.carousel', function (event) {
        printCarouselNumbers(event.target);
    });

    const printAll = () => {
        $('.carousel').each(function () {
            printCarouselNumbers($(this));
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', printAll);
    } else {
        printAll();
    }
}

function printCarouselNumbers(t) {
    let totalItems = $(t).find('.carousel-item').length;
    let currentIndex = $(t).find('div.active').index() + 1;
    $(t).find('.number').html('' + currentIndex + '/' + totalItems + '');
}
